<script setup lang="ts">
const {
  value = 0,
  count = 5,
  svg = '_svg18',
} = defineProps<{
  svg?: '_svg18' | '_svg24'
  value?: number
  count?: number
}>()

const filledPath = 'm12.0025 4 2.8593 4.9091 5.5524 1.2024-3.7852 4.2363L17.2012 20l-5.1987-2.2909L6.8038 20l.5723-5.6522-3.7853-4.2363 5.5524-1.2024L12.0025 4z'

const outlinePath =
  'M14.8589 8.9091 11.9996 4 9.1403 8.9091l-5.5524 1.2024 3.7853 4.2363L6.8008 20l5.1987-2.2909L17.1983 20l-.5723-5.6522 3.7853-4.2363-5.5524-1.2024zm1.7718 2.4307-3.0569-.6619-1.5742-2.7028-1.5742 2.7028-3.057.6619 2.084 2.3324-.315 3.1119 2.8622-1.2613 2.8622 1.2613-.3151-3.1119 2.084-2.3324z'

const init1 = useInited('init1')

const uid = useId()
const id = (nr: number) => `${uid}-star-${nr}`

function fillPercent(nr: number) {
  const fill = value - (nr - 1)
  return Math.max(0, Math.min(1, fill)) * 100
}
</script>

<template>
  <span class="_row _inline _ctrY" :aria-label="`${value} out of ${count} stars`" role="img">
    <template v-if="init1">
      <svg v-for="nr in count" :key="nr" :class="[$style.star, svg]" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
        <defs>
          <clipPath :id="id(nr)">
            <rect x="0" y="0" :width="`${fillPercent(nr)}%`" height="24" />
          </clipPath>
        </defs>

        <path :class="$style.outline" :d="outlinePath" />
        <path :class="$style.fill" :d="filledPath" :clip-path="`url(#${id(nr)})`" />
      </svg>
    </template>
  </span>
</template>

<style module>
.star {
  composes: global(_inline);
  vertical-align: middle;
  margin-left: -3px;
}
.fill {
  fill: currentColor;
}
.outline {
  fill: currentColor;
  opacity: 0.28;
}
</style>
